<template>
	<div class="tw-flex tw--mx-3">	
		<div class="px-3 tw-w-3/5">
			<p-card class="tw-mb-4">
				<div class="tw-flex tw-flex-col tw-justify-between tw-pr-72 tw-px-5">
					<span :style="`color:${$appColors.info}`">
						<b class="uppercase">Nombre del Proceso de Selección: </b> {{ dataProcessSelected.steps.config[0].details.name }}
					</span>
					<span :style="`color:${$appColors.info}`">
						<b class="uppercase">Fecha de Contratación: </b> {{ dataProcessSelected.steps.config[0].details.hireDate | formatDate }}
					</span>
				</div>
			</p-card>
			<p-card class="tw-mb-4">
				<p class="title-imp uppercase">Importación de Postulantes:</p>
				<p class="subtitle">Presionar el check para activar la plataforma en este proceso:</p>
				<div class="tw-flex tw-flex-wrap tw--mx-2">
					<div
						class="tw-w-1/2 lg:tw-w-1/3 2xl:tw-w-1/5 tw-px-2 tw-mb-4"
						v-for="(platform, index) in platforms.data"
						:key="index">
						<square-box
							:logo="platform.urlLogo"
							:checked="verifyRegister(platform)"
							:focused="selectedPlatform.name === platform.name"
							:completed="verifyRegister(platform)"
							:assigned="validAssinged(platform)"
							:quantity="totalItems"
							@handle-click="handlePlatformSelected($event, platform)"
							@onViewClick="handleViewProcess"
							@onAddClick="handleInsertUrl">
						</square-box>
					</div>
				</div>
				
			</p-card>
			<div class="tw-flex tw-justify-center">
				<p-button
					type="primary"
					:disabled="true"
					@click="saveProcess">Guardar Proceso</p-button>
			</div>
		</div>
		<div class="tw-w-2/5">
			<model-description
				:title="'IMPORTAR POSTULANTES'"
				:subtitle="'INSTRUCCIONES'">
				<div v-if="insertURL" class="tw-my-4 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
					<div class="tw-w-full" v-if="flagEditURL">
						<p class="tw-mb-12 tw-text-center">
							Link Ingresado: 
						</p>
						<p v-if="!modifyURL">{{ urlProcess }}</p>
						<input
							v-if="modifyURL"
							class="applicant-input tw-mb-12"
							type="text"
							v-model="urlProcess">
						<p-button
							v-if="!modifyURL"
							type="secondary"
							@click="modifyURL = true">Modificar</p-button>
						<p-button
							v-if="modifyURL"
							type="primary"
							@click="handleUpdateUrlProcess">Guardar</p-button>
					</div>
					<div class="tw-w-full" v-else>
						<p class="tw-mb-12 tw-text-center">
							Ingresa el link correspondiente al aviso en la plataforma seleccionada:
						</p>
						<input
							class="applicant-input tw-mb-12"
							type="text"
							v-model="urlProcess">
						<p-button
							type="primary"
							:disabled="!urlProcess"
							@click="handleImportApplicants">Importar postulantes</p-button>
					</div>
				</div>
				<div v-else-if="showViewProcess" slot="content">
					<p class="tw-mb-3 tw-text-center uppercase">Importaciones</p>
					<app-table
						:filter-columns="false"
						:input-search="false"
						:rows="rows"
						:columns="columns"
						:last-page="lastPage"
						:items-total-quantity="totalItems"
						:current-page="currentPage"
						@on-page="changePage">
						<template slot="rows" slot-scope="props">
							<td v-show="showRow(columns, 1)">{{ props.index + 1 }}</td>
							<td v-show="showRow(columns, 2)">{{ props.row.createdAt | formatDate }}</td>
							<td v-show="showRow(columns, 3)" style="text-align: center;">{{ props.row.newApplicants }}</td>
							<td v-show="showRow(columns, 4)">
								<template>
									<app-tooltip-button
										icon="circle"
										:color="props.row.flagActive === 1 ? 'success' : 'secondary'"
										:text="props.row.flagActive === 1 ? 'En Proceso' : 'Terminado'"
									/>
								</template>
							</td>
							<td v-show="showRow(columns, 5)" @click.stop="stopClick">
								<app-tooltip-button
									img="/static/img/eye.svg"
									size="18"
									text="Ver"
									@click-icon="goToListApplicantsByProcess(props.row)"/>
							</td>
						</template>
					</app-table>
				</div>
				<div v-else class="tw-my-4 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
					<p class="tw-mb-12 tw-text-left">
						1. Active las plataformas que integrará en este proceso.<br>
						2. Ingrese el link del aviso del cual quiere importar postulantes.<br>
						3. Puede importar postulantes las veces que considerenecesario.<br>
					</p>
				</div>
				
				
			</model-description>
		</div>
		<v-dialog
			v-model="isVisible"
			presistent
			max-width="500">
			<p-card class="tw-p-none overflow-hidden">
				<p-header-dialog :negative-margin="false" @closeClicked="close()">
					{{ `Está seguro de activar ${selectedPlatform.name}` }}
				</p-header-dialog>
				<div class="tw-flex tw-justify-center tw-items-center tw-gap-3 tw-py-4">
					<p-button
						type="primary"
						@click="doneActive"
						>Aceptar
					</p-button>
					<p-button
						type="black"
						@click="close()"
						>Cancelar
					</p-button>
				</div>
			</p-card>
		</v-dialog>
		<v-dialog v-model="showAlertNoAssigned" persistent width="400">
			<p-card class="tw-flex tw-flex-col tw-m-0">
				<div class="tw-flex tw-flex-col tw-text-center" :style="`color:${$appColors.info}; font-weight: bold;`">
					<p>No tiene asignada esta plataforma...</p>
					<p>Contactese con soporte.</p>
				</div>
				<p-horizontal-divider></p-horizontal-divider>
				<div class="tw-flex tw-justify-center tw-items-center">
					<p-button type="primary" @click="showAlertNoAssigned = false">Aceptar</p-button>
				</div>
			</p-card>
		</v-dialog>
	</div>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import squareBox from '@/modules/recruitment/components/content/square-box';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';

const { getLocalData } = helper;

export default {
	name: 'import-applicant',
	data() {
		return {
			selectedPlatform: {},
			isVisible: false,
			insertURL: false,
			companyData: {},
			assignPlatforms: [],
			showAlertNoAssigned: false,
			showViewProcess: false,
			urlProcess: null,
			columns: [
				{
					id: 1,
					name: 'Subproceso',
					value: 'sub-process',
					checked: true,
					visible: true,
				},
				{
					id: 2,
					name: 'Fecha',
					value: 'startDate',
					checked: true,
					visible: true,
				},
				{
					id: 3,
					name: 'Cant.Postulantes',
					value: 'quantity',
					checked: true,
					visible: true,
				},
				{
					id: 4,
					name: 'Estado',
					value: 'state',
					checked: true,
					visible: true,
				},
				{
					id: 5,
					name: 'Acciones',
					checked: true,
					visible: true,
				},
			],
			rows: [],
			params: {
				page: 1,
				limit: 5,
			},
			lastPage: 0,
			totalItems: 0,
			currentPage: 1,
			flagEditURL: false,
			modifyURL: false,
		};
	},
	created() {
		this.$store.dispatch('jobEvaluation/loadPlatforms');
		this.loadCompanyDetail();
	},
	components: {
		PCard,
		PButton,
		PHorizontalDivider,
		modelDescription,
		squareBox,
		CloseIcon,
		PHeaderDialog,
	},
	methods: {
		saveProcess() {
			this.goTo('list-applicants');
		},
		async handlePlatformSelected(type, platform) {
			this.insertURL = false;
			this.showViewProcess = false;
			this.urlProcess = null;
			this.modifyURL = false;
			if (type === 'assigned') {
				// this.isVisible = true;
				this.selectedPlatform = platform;
				const params = {
					...this.params,
					platformIds: this.selectedPlatform.id,
					sortDirection: 'ASC',
				};
				params.page = 1;
				try {
					const { data: response, headers } = await this.$httpPraktiko.get(`sub-process/${this.dataProcessSelected.id}`, { params });
					this.rows = response;
					this.flagEditURL = this.rows.length > 0;
					this.urlProcess = this.rows.length > 0 ? this.rows[0].urlPlatform : null;
					this.lastPage = Number(headers['x-last-page']);
					this.totalItems = Number(headers['x-quantity']);
				} catch (error) {
					this.showGenericError();
				}
			} else {
				this.showAlertNoAssigned = true;
				this.flagEditURL = false;
			}
		},
		close() {
			this.isVisible = false;
			this.selectedPlatform = {};
		},
		doneActive() {
			this.isVisible = false;
		},
		handleViewProcess() {
			this.insertURL = false;
			this.showViewProcess = true;
		},
		handleInsertUrl() {
			this.showViewProcess = false;
			this.insertURL = true;
		},
		async loadCompanyDetail() {
			const userInfo = helper.getLocalData('praktiko-user');
			const { company } = userInfo;
			try {
				const { data: response } = await this.$httpPraktiko.get(`/companies/detail/${company.id}`);
				this.companyData = response;
				this.assignPlatforms = response.assignedPlatforms;
			} catch (error) {
				this.showGenericError();
			}
		},
		validAssinged(platform) {
			return this.assignPlatforms.some(item => item.code === platform.code);
		},
		verifyRegister(platform) {
			return this.companyData.integrations &&
				Object.prototype.hasOwnProperty.call(this.companyData.integrations, platform.code);
		},
		async handleImportApplicants() {
			const body = {
				credentialId: this.companyData.integrations[this.selectedPlatform.code].id,
				recruitmentId: this.dataProcessSelected.id,
				sourcePlatform: this.selectedPlatform,
				urlPlatform: this.urlProcess,
			};
			try {
				await this.$httpPraktiko.post('applicants-recruitment/scraper', body);
				this.showNotification('Se estan cargando los postulantes, esto podría tomar unos minutos.');
			} catch (error) {
				this.showGenericError();
			}
		},
		async handleUpdateUrlProcess() {
			const body = {
				urlPlatform: this.urlProcess,
			};
			try {
				await this.$httpPraktiko.patch(`sub-process/${this.dataProcessSelected.id}`, body);
				this.showNotification('URL Actualizada Correctamente');
				this.handleImportApplicants();
				this.handlePlatformSelected('assigned', this.selectedPlatform);
				this.modifyURL = false;
				this.showNotification('Se estan cargando los postulantes, esto podría tomar unos minutos.');
			} catch (error) {
				this.showGenericError();
			}
		},
		changePage(page) {
			this.params.page = page;
			this.currentPage = page;
			this.changePageOnTable();
		},
		async changePageOnTable() {
			const params = {
				...this.params,
				platformIds: this.selectedPlatform.id,
				sortDirection: 'ASC',
			};
			try {
				const { data: response, headers } = await this.$httpPraktiko.get(`sub-process/${this.dataProcessSelected.id}`, { params });
				this.rows = response;
				this.lastPage = Number(headers['x-last-page']);
				this.totalItems = Number(headers['x-quantity']);
			} catch (error) {
				this.showGenericError();
			}
		},
		goToListApplicantsByProcess(row) {
			this.goTo('list-applicants', { params: { id: row.id } });
		},
	},
	computed: {
		...mapState('recruitment', {
			dataProcessSelected(state) {
				return pathOr(getLocalData('dataProcessSelected'), ['recruitmentFlow', 'dataProcessSelected'], state.recruitment) || [];
			},
			typeProcess: pathOr([], ['dataSelection', 'typeProcess']),
			typeApplicant: pathOr([], ['dataSelection', 'typeApplicant']),
		}),
		...mapState('jobEvaluation', {
			platforms: pathOr([], ['supplies', 'generalData', 'platforms']),
		}),
	},
};
</script>

<style lang="scss" scoped>
	.title-imp {
		color: color(black) !important;
		font-size: size(large);
		font-family: font(bold);
	}
	.subtitle {
		color: color(black) !important;
		font-size: size(medium);
	}
	.applicant-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, green-dark);
		border-radius: 4px;
		display: block;
		outline: none;
		color: map-get($colors, gray-sidebar);
		padding: 5px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/import-applicants/import-applicant.vue